import * as R from 'ramda'
import urlManager from '@/urlManager'
import service from '../../service'
import Vue from 'vue'

export default {
  namespaced: true,
  state() {
    return {
      lists: {}
    }
  },
  getters: {
    userLists: state => teamId => state.lists[teamId],
    listById: state => listId =>
      Object.values(state.lists)
        .flat()
        .find(list => list.id === +listId)
  },
  mutations: {
    SET_USER_LISTS(state, { teamId, userLists }) {
      Vue.set(state.lists, teamId, userLists)
    },
    SET_USER_LIST(state, { teamId, userList }) {
      if (!state.lists[teamId]) {
        Vue.set(state.lists, teamId, [])
      }
      let teamLists = state.lists[teamId]
      const index = teamLists.findIndex(list => list.id === userList.id)
      teamLists = R.update(index, userList, teamLists)
      Vue.set(state.lists, teamId, teamLists)
    },
    UPDATE_USER_LIST(state, { teamId, id, value }) {
      let teamLists = state.lists[teamId]
      const index = teamLists.findIndex(list => list.id === id)
      if (index === -1) return
      teamLists = R.update(index, { ...teamLists[index], filterData: value }, teamLists)
      Vue.set(state.lists, teamId, teamLists)
    },
    DELETE_USER_LIST(state, { teamId, id }) {
      let teamLists = state.lists[teamId]
      teamLists = teamLists.filter(list => list.id !== id)
      Vue.set(state.lists, teamId, teamLists)
    }
  },
  actions: {
    async createUserList({ commit }, payload) {
      const response = await service.client.post(
        urlManager.userLists(payload.organizationId),
        payload
      )
      commit('SET_USER_LIST', {
        teamId: payload.teamId,
        userList: response.data
      })
      return response.data
    },
    async getUserLists({ commit }, { orgId, teamId }) {
      const response = await service.client.get(urlManager.userLists(orgId), {
        params: {
          team_id: teamId
        }
      })
      commit('SET_USER_LISTS', { teamId, userLists: response.data })
      return response.data
    },
    async updateUserList({ commit }, { organizationId, teamId, id, filterData }) {
      const response = await service.client.patch(
        urlManager.userListDetail(organizationId, id),
        { filterData: filterData } // need to add support for name change
      )
      commit('UPDATE_USER_LIST', {
        teamId: teamId,
        id: id,
        value: filterData
      })
      return response.data
    },
    async deleteUserList({ commit }, { organizationId, teamId, id }) {
      const response = await service.client.delete(urlManager.userListDetail(organizationId, id))
      commit('DELETE_USER_LIST', {
        teamId,
        id
      })
      return response.data
    }
  }
}
